import { render } from "./VXPCircleLogo.vue?vue&type=template&id=38c483cc"
const script = {}

import "./VXPCircleLogo.vue?vue&type=style&index=0&id=38c483cc&lang=css"

import exportComponent from "/tmp/build_1ea34a31/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__